import { Link } from 'react-router-dom';

const columns = [
  {
    title: '快速导航',
    links: [
      { to: '/', label: '首页' },
      { to: '/topics', label: '热门瓜料' },
      { to: '/community', label: '讨论区' },
      { to: '/about', label: '关于我们' },
    ],
  },
  {
    title: '内容分类',
    links: [
      { to: '/topics?c=romance', label: '恋情绯闻' },
      { to: '/topics?c=backstage', label: '影视幕后' },
      { to: '/topics?c=variety', label: '综艺现场' },
      { to: '/topics?c=music', label: '音乐动态' },
    ],
  },
  {
    title: '社群与帮助',
    links: [
      { to: '/community', label: '群聊入口' },
      { to: '/community', label: '贴吧版面' },
      { to: '/about#faq', label: '常见问题' },
      { to: '/about#contact', label: '内容更正' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" aria-hidden="true" />
              </span>
              <strong className="font-heading text-xl font-black text-background-50">爆料吃瓜</strong>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              把散落的娱乐爆料整理成看得懂的时间线，标注来源与证据完整度，让每一次围观都有落脚点。
              我们不制造结论，只提供讨论的场地。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['话题讨论', '网友观点', '群聊入口'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-800/70 px-3 py-1 text-xs text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {column.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/80 transition-colors hover:text-primary-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-xs leading-relaxed text-background-300/70">
            © 2026 爆料吃瓜 · 站内内容均为网友讨论与公开信息整理，不构成对任何个人或机构的结论性评价。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-background-300/70">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line" aria-hidden="true" />
              contact@baoliaochigua.com
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-line" aria-hidden="true" />
              不接立场投放
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}